<template>
  <div>
    <v-container class="fill-height h-80" fluid>
      <v-row no-gutters>
        <template v-if="customer === null">
          <v-col sm="4" lg="3" class="mx-auto">
            <v-img :src="require('@/assets/imgs/no_data/call.svg')"></v-img>
          </v-col>
          <v-col cols="12">
            <h2 class="text-center mt-5">
              Search by Phone Number , Account ID , Email
            </h2>
          </v-col>
        </template>
        <v-col
          cols="12"
          :sm="callToggle ? '10' : '8'"
          class="mx-auto search-input"
        >
          <v-text-field
            outlined
            rounded
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            :append-icon="showIcon ? 'Search' : '--'"
            v-on:keyup.enter="searchFilter"
            @click:append="searchFilter"
          ></v-text-field>
        </v-col>
        <template v-if="customer !== null">
          <v-col cols="12" sm="2" v-if="callToggle">
            <v-btn
              width="100%"
              class="button mx-1 h-54"
              rounded
              large
              color="success"
              :loading="loadingCall"
              @click="buttonsToggle"
            >
              <v-icon>mdi-phone</v-icon>
              <span class="mx-2">Start Interaction</span>
            </v-btn>
          </v-col>
          <!-- <v-col cols="12" v-if="callToggle">
            <StopWatch />
          </v-col> -->
          <v-col
            v-if="!callToggle"
            cols="12"
            sm="2"
            class="d-flex justify-center mt-4"
          >
            <span class="red--text font-weight-bold font-lg">
              {{ timer.hours }} : {{ timer.minutes }} : {{ timer.seconds }}
            </span>
          </v-col>
          <v-col cols="12" sm="2" v-if="!callToggle">
            <v-btn
              width="100%"
              class="button mx-1 h-54"
              large
              rounded
              color="error"
              @click="endCallBegin"
            >
              <v-icon>mdi-phone-paused</v-icon>
              <span class="mx-2">Wrap Up</span>
            </v-btn>
          </v-col>
          <v-btn
            class="notes-btn"
            v-if="!callToggle"
            outlined
            large
            color="primary"
            @click="notesToggleAction"
            >Notes</v-btn
          >
        </template>
      </v-row>
      <v-row v-if="customer !== null">
        <v-col cols="12" xl="5" md="6" v-if="parentInfo.length > 0">
          <family-info
            :parentInfo="parentInfo"
            :childrenInfo="childrenInfo"
            :addressInfo="addressInfo"
          />
        </v-col>
        <v-col cols="12" xl="7" md="6">
          <tasks :tasks="tasks" />
        </v-col>
        <v-col cols="12" xl="4" md="6" v-if="bookedCamps.length > 0">
          <booked-camps :bookedCamps="bookedCamps" />
        </v-col>
        <v-col cols="12" xl="8" md="6">
          <interactions :interactions="interactions" />
        </v-col>
      </v-row>
      <!-- Wrap Up Dialog -->
      <v-dialog v-model="taskDialog" max-width="75%">
        <task-modal
          :interaction_serial="interaction_serial"
          :task_id="task_id"
          :dialogNotes="dialogNotes"
          :task_serial="task_serial"
          :timer="timer"
          @endCall="endCall"
        />
      </v-dialog>
      <!-- Notes Dialog -->
      <v-dialog v-model="notesToggle" max-width="500px">
        <v-card>
          <v-card-title>
            <h3>Notes</h3>
          </v-card-title>
          <v-card-text>
            <form class="form-box" @submit.prevent="saveNotes">
              <v-col class="py-2" cols="12">
                <v-textarea
                  label="Notes"
                  regular
                  v-model="form.notes"
                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="6">
                <v-btn color="primary" large type="submit">{{
                  $t("button.save")
                }}</v-btn>
              </v-col>
            </form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import { IndexData, StoreData, UpdateData } from "@/helpers/apiMethods";
export default {
  props: {
    task_id: {
      type: Number,
      default: () => {}
    },
    task_serial: {
      type: String,
      default: () => {}
    },
    interaction_serial: {
      type: String,
      default: () => {}
    },
    task_interaction: {
      type: Object,
      default: () => {}
    },
    timer: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    FamilyInfo: () => import("./sub/FamilyInfo"),
    BookedCamps: () => import("./sub/BookedCamps"),
    Tasks: () => import("./sub/Tasks"),
    Interactions: () => import("./sub/Interactions"),
    // StopWatch: () => import("./sub/StopWatch"),
    TaskModal: () => import("./sub/TaskModal")
  },
  data() {
    return {
      search: "",
      customer: null,
      parentInfo: [],
      addressInfo: [],
      childrenInfo: [],
      bookedCamps: [],
      tasks: [],
      interactions: [],
      taskDialog: false,
      notesToggle: false,
      loadingCall: false,
      showIcon: true,
      form: {
        notes: "",
        notes_only: true
      },
      dialogNotes: ""
    };
  },
  methods: {
    toggleMarker(query) {
      const convertedQuery = { search: encodeURIComponent(query.search) };
      IndexData({
        reqName: `/crm/customers`,
        query: convertedQuery
      })
        .then(res => {
          const { customer } = res.data;
          this.customer = customer;
          this.parentInfo = customer.parents;
          this.addressInfo = customer.address_details;
          this.childrenInfo = customer.children;
          this.bookedCamps = customer.booked_camps;
          this.interactions = customer.related_interactions;
          this.tasks = customer.related_tasks;
        })
        .catch(() => {});
    },
    buttonsToggle() {
      this.loadingCall = true;
      const formData = new FormData();
      formData.append("mobile", this.search);
      if (this.task_id == undefined || this.task_id == null) {
        delete this.task_id;
      } else {
        formData.append("task_id", this.task_id);
      }
      StoreData({
        reqName: `crm/interactions`,
        data: formData
        // data: { mobile: this.search }
      })
        .then(res => {
          this.interaction_serial = res.data.interaction.serial;

          this.loadingCall = false;
          this.callToggle = false;
          this.startCallToggle = true;
          // this.available_teams.push(res.data.camp_team);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loadingCall = false;
        });
    },
    endCallBegin() {
      this.taskDialog = true;
    },
    endCall() {
      this.taskDialog = false;
      // this.callToggle = true;
      this.interaction_serial = null;
      this.task_id = null;
      this.task_serial = null;
    },
    notesToggleAction() {
      this.notesToggle = true;
    },
    saveNotes() {
      const formData = new FormData();
      formData.append("_method", "put");
      Object.keys(this.form).forEach(formItem => {
        formData.append(formItem, this.form[formItem]);
      });
      UpdateData({
        reqName: `crm/interactions`,
        data: formData,
        id: this.interaction_serial
      })
        .then(res => {
          this.notesToggle = false;
          this.form.notes = "";
          this.dialogNotes = res.data.interaction.notes;
        })
        .catch(() => {})
        .finally(() => {});
    },
    searchFilter() {
      const query = { ...this.$route.query, search: this.search };
      this.$router.push({ query });
    }
  },
  computed: {
    query() {
      const query = {};
      if (this.search) {
        query.search = this.search;
      }
      return query;
    },
    callToggle() {
      return this.interaction_serial == null;
    }
  },
  watch: {
    $route: {
      handler({ query }) {
        if (query.search != undefined) {
          this.toggleMarker(query);
          this.search = query.search;
        }
      },
      immediate: true
    },
    callToggle: {
      handler(newVal) {
        this.$emit("callToggleChange", newVal);
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.font-lg {
  font-size: 1.2rem !important;
}
</style>
